module.exports = __webpack_public_path__ + "img/img06.3f9a7431.svg";